import { useLocalSearchParams } from 'expo-router';

import EditAccount from '../../../../banking/components/income-split/editor/subscreens/EditAccount';
import EditAccountNew from '../../../../banking/components/income-split/editor/subscreens/EditAccountNew';
import useShouldSeeTiedRules from '../../../../banking/hooks/income-split/useShouldSeeRuleSets';

export default function IncomeSplitEditAccountScreen() {
    const { tiedRules } = useLocalSearchParams<{
        tiedRules: string;
    }>();

    const enableTiedRules = useShouldSeeTiedRules();

    if (tiedRules === 'true' && enableTiedRules) {
        return <EditAccountNew />;
    }
    return <EditAccount />;
}
